import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { LoaderComponent } from 'components/Loader';
import {
  StyledModalContainer,
  StyledFocusableActionsWrapper,
  StyledTitle,
  StyledDescription,
  StyledWhiteText,
  StyledButtonWrapper,
  StyledButtonText,
  StyledLoaderWrapper,
  StyledPendingDescription,
} from './StyledComponents';

/**
 * Параметр "onModalBack" называется так только для совместимости интерфейса
 * с остальными модальными окнами (в этом окне никакой кнопки "back" нет)
 */
export const InfoModal = ({ message, onModalBack, buttonText = 'OK' }) => (
  <StyledModalContainer>
    <StyledTitle>{message}</StyledTitle>
    <StyledFocusableActionsWrapper
      config={{
        leaveFor: {
          right: '',
          up: '',
          left: '',
          down: '',
        },
      }}
      defaultSection
    >
      <StyledButtonWrapper>
        <Button onEnter={onModalBack}>
          <StyledButtonText>{buttonText}</StyledButtonText>
        </Button>
      </StyledButtonWrapper>
    </StyledFocusableActionsWrapper>
  </StyledModalContainer>
);

InfoModal.propTypes = {
  message: PropTypes.string.isRequired,
  onModalBack: PropTypes.func.isRequired,
};

export const ConfirmModal = ({
  message,
  description,
  onModalBack,
  onModalConfirm,
  confirmText,
  rejectText,
}) => (
  <StyledModalContainer>
    <StyledTitle>
      {message}
      <StyledDescription>{description}</StyledDescription>
    </StyledTitle>
    <StyledFocusableActionsWrapper
      config={{
        leaveFor: {
          right: '',
          up: '',
          left: '',
          down: '',
        },
      }}
      defaultSection
    >
      <StyledButtonWrapper>
        <Button onEnter={onModalConfirm} focusOnMouseEnter>
          <StyledButtonText>{confirmText}</StyledButtonText>
        </Button>
      </StyledButtonWrapper>
      <StyledButtonWrapper>
        <Button onEnter={onModalBack} focusOnMouseEnter>
          <StyledButtonText>{rejectText}</StyledButtonText>
        </Button>
      </StyledButtonWrapper>
    </StyledFocusableActionsWrapper>
  </StyledModalContainer>
);

ConfirmModal.propTypes = {
  message: PropTypes.string.isRequired,
  onModalBack: PropTypes.func.isRequired,
  onModalConfirm: PropTypes.func.isRequired,
  description: PropTypes.string,
  confirmText: PropTypes.string,
  rejectText: PropTypes.string,
};

ConfirmModal.defaultProps = {
  confirmText: 'OK',
  rejectText: 'Cancel',
};

export const LoginModal = ({
  title,
  description,
  highlightedValue,
  rejectText,
  options,
  onModalConfirm,
  onModalBack,
}) => {
  let messageComponent = description;
  if (highlightedValue) {
    const index = description.indexOf(highlightedValue);
    messageComponent = [
      description.slice(0, index),
      <StyledWhiteText key="highlighted">{highlightedValue}</StyledWhiteText>,
      description.slice(index + highlightedValue.length),
    ];
  }

  return (
    <StyledModalContainer>
      <StyledTitle>
        {title}
        <StyledDescription>{messageComponent}</StyledDescription>
      </StyledTitle>
      <StyledFocusableActionsWrapper
        config={{
          leaveFor: {
            right: '',
            up: '',
            left: '',
            down: '',
          },
        }}
        defaultSection
      >
        {options.map(({ type, label }, i) => (
          <StyledButtonWrapper key={i}>
            <Button onEnter={() => onModalConfirm(type)} focusOnMouseEnter>
              <StyledButtonText>{label}</StyledButtonText>
            </Button>
          </StyledButtonWrapper>
        ))}
        <StyledButtonWrapper>
          <Button onEnter={onModalBack} focusOnMouseEnter>
            <StyledButtonText>{rejectText}</StyledButtonText>
          </Button>
        </StyledButtonWrapper>
      </StyledFocusableActionsWrapper>
    </StyledModalContainer>
  );
};

LoginModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  highlightedValue: PropTypes.string,
  options: PropTypes.array.isRequired,
  rejectText: PropTypes.string,
  onModalBack: PropTypes.func.isRequired,
  onModalConfirm: PropTypes.func.isRequired,
};

LoginModal.defaultProps = {
  rejectText: 'Cancel',
};

export const PendingModal = ({ message, onModalBack, buttonText = 'OK' }) => (
  <StyledModalContainer>
    <StyledLoaderWrapper>
      <LoaderComponent />
    </StyledLoaderWrapper>
    <StyledTitle>
      <StyledPendingDescription>{message}</StyledPendingDescription>
    </StyledTitle>
    <StyledFocusableActionsWrapper
      config={{
        leaveFor: {
          right: '',
          up: '',
          left: '',
          down: '',
        },
      }}
      defaultSection
    >
      <StyledButtonWrapper>
        <Button onEnter={onModalBack}>
          <StyledButtonText>{buttonText}</StyledButtonText>
        </Button>
      </StyledButtonWrapper>
    </StyledFocusableActionsWrapper>
  </StyledModalContainer>
);

PendingModal.propTypes = {
  message: PropTypes.string.isRequired,
  onModalBack: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
